<template>
  <div class="kontonummer-container">
    <ul class="nav nav-tabs">
      <li class="nav-item">
        <a class="nav-link" :class="{ active: activeTab === 'generator' }" href="#" @click.prevent="activeTab = 'generator'">Generator</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" :class="{ active: activeTab === 'validator' }" href="#" @click.prevent="activeTab = 'validator'">Validator</a>
      </li>
    </ul>

    <!-- Generator Tab -->
    <div v-if="activeTab === 'generator'" class="tab-content">
      <h3>Generer fiktive bankopplysninger</h3>
      <div class="description-text">
        Generer dine egne fiktive kontonummer og KID-numre. Tallene er
        MOD11/MOD10-gyldige. Dataene genereres i din egen nettleser.
      </div>

      <div class="row mt-4">
        <!-- IBAN Generator -->


        <!-- Kontonummer Generator -->
        <div class="col-md-6">
          <div class="card">
            <div class="card-header">
              <h5 class="card-title mb-0">Kontonummer Generator</h5>
            </div>
            <div class="card-body">
              <p class="text-muted small">Generer et tilfeldig, gyldig norsk kontonummer (11 siffer) eller IBAN.</p>
              <button @click="genererKontonummer" class="btn btn-primary mb-3 me-2">Generer Kontonummer</button>
              <button @click="genererKontonummerSomIban" class="btn btn-secondary mb-3">Generer som IBAN</button>

              <div v-if="generatedKontonummere.length > 0" class="generated-list">
                <div v-for="konto in generatedKontonummere" :key="konto.uuid" class="generated-item card mb-2">
                  <div class="card-content">
                    <button @click="fjernKontonummer(konto.uuid)" type="button" class="btn-close close-button" aria-label="Close"></button>
                    <p class="mb-1">
                      <span v-if="konto.iban" class="badge bg-primary">IBAN</span>
                      <span class="badge bg-secondary">{{ konto.formatted }}</span>
                    </p>
                    <p class="mb-0">
                      {{ konto.iban || konto.raw }}
                      <button @click="leggVerdiTilClipboard(konto.iban || konto.raw)" type="button" class="copy-button" title="Kopier til utklippstavle">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z"></path>
                          <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"></path>
                          <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"></path>
                        </svg>
                      </button>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- KID Generator -->
        <div class="col-md-6">
          <div class="card">
            <div class="card-header">
              <h5 class="card-title mb-0">KID Generator</h5>
            </div>
            <div class="card-body">
              <p class="text-muted small">Generer et gyldig KID-nummer basert på din kundeidentifikator.</p>

              <div class="mb-3">
                <label for="kidBase" class="form-label">Kundeidentifikator (1-24 siffer)</label>
                <input type="text" class="form-control" id="kidBase" v-model="kidBaseInput"
                       placeholder="f.eks. 12345678">
                <div v-if="kidGeneratorError" class="text-danger small mt-1">{{ kidGeneratorError }}</div>
              </div>

              <div class="mb-3">
                <label class="form-label">Algoritme</label>
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="kidAlgorithm" id="kidMod10" value="MOD10" v-model="kidAlgorithm">
                  <label class="form-check-label" for="kidMod10">MOD10 (Luhn)</label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="kidAlgorithm" id="kidMod11" value="MOD11" v-model="kidAlgorithm">
                  <label class="form-check-label" for="kidMod11">MOD11</label>
                </div>
              </div>

              <button @click="genererKid" class="btn btn-primary mb-3" :disabled="!canGenerateKid">Generer KID</button>

              <div v-if="generatedKids.length > 0" class="generated-list">
                <div v-for="kid in generatedKids" :key="kid.uuid" class="generated-item card mb-2">
                  <div class="card-content">
                    <button @click="fjernKid(kid.uuid)" type="button" class="btn-close close-button" aria-label="Close"></button>
                    <p class="mb-1">
                      <span class="badge bg-secondary">{{ kid.algorithm }}</span>
                    </p>
                    <p class="mb-0">
                      {{ kid.value }}
                      <button @click="leggVerdiTilClipboard(kid.value)" type="button" class="copy-button" title="Kopier til utklippstavle">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16">
                          <path fill-rule="evenodd" d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z"></path>
                          <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"></path>
                          <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"></path>
                        </svg>
                      </button>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Validator Tab -->
    <div v-if="activeTab === 'validator'" class="tab-content">
      <h3>Valider bankopplysninger</h3>
      <p class="mb-4">Valider norske kontonummer, KID-numre og IBAN</p>

      <!-- IBAN Validator -->
      <div class="row mb-4">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <h5 class="card-title mb-0">IBAN</h5>
            </div>
            <div class="card-body">
              <div v-if="ibanValidatorText" class="alert alert-danger" role="alert">
                {{ ibanValidatorText }}
              </div>
              <div class="mb-3">
                <label for="iban" class="form-label">Skriv inn IBAN (norsk: 15 tegn)</label>
                <input type="text" class="form-control" id="iban" v-model="typedIban"
                       placeholder="f.eks. NO9386011117947 eller NO93 8601 1117 947">
              </div>

              <div v-if="ibanData" class="card">
                <div class="card-header">
                  <h6 class="card-title mb-0">IBAN informasjon</h6>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-6">
                      <strong>Status:</strong>
                      <span :class="['badge', ibanData.isValid ? 'bg-success' : 'bg-danger']">
                        {{ ibanData.isValid ? 'Gyldig' : 'Ugyldig' }}
                      </span>
                    </div>
                    <div class="col-6">
                      <strong>Land:</strong>
                      <span class="badge bg-primary">{{ ibanData.country }}</span>
                    </div>
                    <div class="col-6 mt-2">
                      <strong>Formatert:</strong> {{ ibanData.formatted }}
                    </div>
                    <div class="col-6 mt-2">
                      <strong>Kontrollsiffer:</strong> {{ ibanData.checkDigits }}
                    </div>
                    <div class="col-6 mt-2">
                      <strong>Kontonummer:</strong> {{ ibanData.kontonummer }}
                    </div>
                    <div class="col-6 mt-2">
                      <strong>Kontonummer gyldig:</strong>
                      <span :class="['badge', ibanData.kontonummerValid ? 'bg-success' : 'bg-danger']">
                        {{ ibanData.kontonummerValid ? 'Ja (MOD11)' : 'Nei' }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="card">
            <div class="card-header">
              <h5 class="card-title mb-0">Kontonummer</h5>
            </div>
            <div class="card-body">
              <div v-if="kontonummerValidatorText" class="alert alert-danger" role="alert">
                {{ kontonummerValidatorText }}
              </div>
              <div class="mb-3">
                <label for="kontonummer" class="form-label">Skriv inn kontonummer (11 siffer)</label>
                <input type="text" class="form-control" id="kontonummer" v-model="typedKontonummer"
                       placeholder="f.eks. 12345678903 eller 1234.56.78903">
              </div>

              <div v-if="kontonummerData" class="card">
                <div class="card-header">
                  <h6 class="card-title mb-0">Kontonummer informasjon</h6>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-6">
                      <strong>Status:</strong>
                      <span :class="['badge', kontonummerData.isValid ? 'bg-success' : 'bg-danger']">
                        {{ kontonummerData.isValid ? 'Gyldig' : 'Ugyldig' }}
                      </span>
                    </div>
                    <div class="col-6">
                      <strong>Format:</strong>
                      <span class="badge bg-secondary">{{ kontonummerData.formatted }}</span>
                    </div>
                    <div class="col-6 mt-2">
                      <strong>Bankkode:</strong> {{ kontonummerData.bankCode }}
                    </div>
                    <div class="col-6 mt-2">
                      <strong>Kontotype:</strong> {{ kontonummerData.accountType }}
                    </div>
                    <div class="col-6 mt-2">
                      <strong>Kontonummer:</strong> {{ kontonummerData.accountNumber }}
                    </div>
                    <div class="col-6 mt-2">
                      <strong>Kontrollsiffer:</strong> {{ kontonummerData.checkDigit }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="card">
            <div class="card-header">
              <h5 class="card-title mb-0">KID-nummer</h5>
            </div>
            <div class="card-body">
              <div v-if="kidValidatorText" class="alert alert-danger" role="alert">
                {{ kidValidatorText }}
              </div>
              <div class="mb-3">
                <label for="kid" class="form-label">Skriv inn KID-nummer (2-25 siffer)</label>
                <input type="text" class="form-control" id="kid" v-model="typedKid"
                       placeholder="f.eks. 12345678 eller 123456789012345">
              </div>

              <div v-if="kidData" class="card">
                <div class="card-header">
                  <h6 class="card-title mb-0">KID informasjon</h6>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-6">
                      <strong>Status:</strong>
                      <span :class="['badge', kidData.isValid ? 'bg-success' : 'bg-danger']">
                        {{ kidData.isValid ? 'Gyldig' : 'Ugyldig' }}
                      </span>
                    </div>
                    <div class="col-6">
                      <strong>Lengde:</strong>
                      <span class="badge bg-info">{{ kidData.length }} siffer</span>
                    </div>
                    <div class="col-6 mt-2">
                      <strong>Kontrollalgoritme:</strong> {{ kidData.algorithm }}
                    </div>
                    <div class="col-6 mt-2">
                      <strong>Kontrollsiffer:</strong> {{ kidData.checkDigit }}
                    </div>
                    <div class="col-12 mt-2">
                      <strong>Kundeidentifikator:</strong> {{ kidData.customerNumber }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KontonummerValidator',
  data() {
    return {
      activeTab: 'generator',
      // Generator data
      generatedKontonummere: [],
      generatedKids: [],
      kidBaseInput: '',
      kidAlgorithm: 'MOD10',
      // Validator data
      typedKontonummer: '',
      typedKid: '',
      typedIban: ''
    }
  },
  computed: {
    kidGeneratorError() {
      const cleanInput = this.kidBaseInput.replace(/\s/g, '')
      if (cleanInput.length === 0) {
        return ''
      }
      if (!/^\d+$/.test(cleanInput)) {
        return 'Kundeidentifikator må kun inneholde tall.'
      }
      if (cleanInput.length > 24) {
        return 'Kundeidentifikator kan ikke være mer enn 24 siffer.'
      }
      return ''
    },
    canGenerateKid() {
      const cleanInput = this.kidBaseInput.replace(/\s/g, '')
      return cleanInput.length > 0 && cleanInput.length <= 24 && /^\d+$/.test(cleanInput)
    },
    kontonummerValidatorText() {
      return this.validateKontonummerNotNumbers() + this.validateKontonummerLength()
    },
    kidValidatorText() {
      return this.validateKidNotNumbers() + this.validateKidLength()
    },
    ibanValidatorText() {
      const cleanIban = this.typedIban.replace(/\s/g, '').toUpperCase()
      if (cleanIban.length === 0) {
        return ''
      }
      if (!/^[A-Z]{2}[0-9A-Z]+$/.test(cleanIban)) {
        return 'IBAN må starte med landskode (2 bokstaver) etterfulgt av tall.'
      }
      // Merk: Vi validerer lengde eksplisitt kun for norske IBAN (NO).
      // For andre land kontrolleres kun grunnleggende format og eventuell sjekksum.
      if (cleanIban.startsWith('NO') && cleanIban.length !== 15) {
        return 'Norsk IBAN må være nøyaktig 15 tegn (NO + 2 kontrollsiffer + 11-sifret kontonummer).'
      }
      return ''
    },
    ibanData() {
      const cleanIban = this.typedIban.replace(/\s/g, '').toUpperCase()
      if (cleanIban.length < 5 || !/^[A-Z]{2}[0-9A-Z]+$/.test(cleanIban)) {
        return null
      }

      const countryCode = cleanIban.substring(0, 2)
      const checkDigits = cleanIban.substring(2, 4)
      const bban = cleanIban.substring(4)

      // For Norwegian IBAN, validate specifically
      const isNorwegian = countryCode === 'NO'
      let kontonummer = ''
      let kontonummerValid = false

      if (isNorwegian && bban.length === 11 && /^\d+$/.test(bban)) {
        kontonummer = `${bban.substring(0, 4)}.${bban.substring(4, 6)}.${bban.substring(6, 11)}`
        kontonummerValid = this.validateKontonummerMOD11(bban)
      }

      // Validate IBAN check digits using MOD97
      const isValid = this.validateIbanChecksum(cleanIban)

      const formatted = cleanIban.replace(/(.{4})/g, '$1 ').trim()

      return {
        isValid,
        country: countryCode,
        checkDigits,
        kontonummer: kontonummer || bban,
        kontonummerValid,
        formatted
      }
    },
    kontonummerData() {
      // Remove any dots/spaces and validate length
      const cleanNumber = this.typedKontonummer.replace(/[\s.]/g, '')
      if (cleanNumber.length !== 11 || !/^\d+$/.test(cleanNumber)) {
        return null
      }

      const bankCode = cleanNumber.substring(0, 4)
      const accountType = cleanNumber.substring(4, 6)
      const accountNumber = cleanNumber.substring(6, 10)
      const checkDigit = cleanNumber.substring(10, 11)

      const isValid = this.validateKontonummerMOD11(cleanNumber)
      const formatted = `${bankCode}.${accountType}.${accountNumber}${checkDigit}`

      return {
        isValid,
        formatted,
        bankCode,
        accountType,
        accountNumber,
        checkDigit
      }
    },
    kidData() {
      const cleanNumber = this.typedKid.replace(/\s/g, '')
      if (cleanNumber.length < 2 || cleanNumber.length > 25 || !/^\d+$/.test(cleanNumber)) {
        return null
      }

      // KID can use MOD10 or MOD11
      const mod10Valid = this.validateKidMOD10(cleanNumber)
      const mod11Valid = this.validateKidMOD11(cleanNumber)

      let algorithm = 'Ukjent'
      let isValid = false

      if (mod10Valid && mod11Valid) {
        algorithm = 'MOD10 og MOD11'
        isValid = true
      } else if (mod10Valid) {
        algorithm = 'MOD10'
        isValid = true
      } else if (mod11Valid) {
        algorithm = 'MOD11'
        isValid = true
      }

      const checkDigit = cleanNumber.charAt(cleanNumber.length - 1)
      const customerNumber = cleanNumber.substring(0, cleanNumber.length - 1)

      return {
        isValid,
        length: cleanNumber.length,
        algorithm,
        checkDigit,
        customerNumber
      }
    }
  },
  methods: {
    // Utility methods
    uuidv4() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
          (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      )
    },
    leggVerdiTilClipboard(value) {
      navigator.clipboard.writeText(value)
    },

    // Kontonummer generator methods
    genererKontonummer() {
      let kontonummer = false
      do {
        kontonummer = this.tryGenerateKontonummer()
      } while (kontonummer === false)
      this.generatedKontonummere.push(kontonummer)
    },
    genererKontonummerSomIban() {
      let kontonummer = false
      do {
        kontonummer = this.tryGenerateKontonummer()
      } while (kontonummer === false)

      // Add IBAN to the generated kontonummer
      const checkDigits = this.calculateIbanCheckDigits(kontonummer.raw)
      const ibanRaw = 'NO' + checkDigits + kontonummer.raw
      kontonummer.iban = ibanRaw.replace(/(.{4})/g, '$1 ').trim()

      this.generatedKontonummere.push(kontonummer)
    },
    calculateIbanCheckDigits(kontonummer) {
      // Norwegian IBAN: NO + check digits + BBAN (11 digits)
      // To calculate check digits:
      // 1. Move country code to end: BBAN + "NO00"
      // 2. Convert letters to numbers: N=23, O=24, so "NO00" = "232400"
      // 3. Calculate: 98 - (number MOD 97)
      const numericIban = kontonummer + '232400'
      const remainder = this.mod97(numericIban)
      const checksum = 98 - remainder
      return checksum.toString().padStart(2, '0')
    },
    tryGenerateKontonummer() {
      // Generate 10 random digits
      let base = ''
      for (let i = 0; i < 10; i++) {
        base += Math.floor(Math.random() * 10).toString()
      }

      // Calculate check digit using MOD11
      const checkDigit = this.calculateKontonummerCheckDigit(base)

      // If check digit is invalid (remainder = 1), retry
      if (checkDigit === false) {
        return false
      }

      const raw = base + checkDigit
      const formatted = `${raw.substring(0, 4)}.${raw.substring(4, 6)}.${raw.substring(6, 11)}`

      return {
        uuid: this.uuidv4(),
        raw: raw,
        formatted: formatted
      }
    },
    calculateKontonummerCheckDigit(base) {
      const factors = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2]
      let sum = 0
      for (let i = 0; i < 10; i++) {
        sum += parseInt(base.charAt(i)) * factors[i]
      }

      const remainder = sum % 11
      if (remainder === 0) {
        return 0
      } else if (remainder === 1) {
        return false // Invalid, need to regenerate
      } else {
        return 11 - remainder
      }
    },
    fjernKontonummer(uuid) {
      this.generatedKontonummere = this.generatedKontonummere.filter(k => k.uuid !== uuid)
    },

    // KID generator methods
    genererKid() {
      const cleanBase = this.kidBaseInput.replace(/\s/g, '')
      if (!this.canGenerateKid) {
        return
      }

      let checkDigit
      if (this.kidAlgorithm === 'MOD10') {
        checkDigit = this.calculateKidMOD10CheckDigit(cleanBase)
      } else {
        checkDigit = this.calculateKidMOD11CheckDigit(cleanBase)
        // If MOD11 returns false (remainder = 1), we cannot generate valid KID
        if (checkDigit === false) {
          // Try adjusting the base by incrementing last digit
          let adjusted = false
          for (let i = 0; i < 10; i++) {
            const newBase = cleanBase.slice(0, -1) + ((parseInt(cleanBase.slice(-1)) + i) % 10).toString()
            checkDigit = this.calculateKidMOD11CheckDigit(newBase)
            if (checkDigit !== false) {
              this.generatedKids.push({
                uuid: this.uuidv4(),
                value: newBase + checkDigit,
                algorithm: this.kidAlgorithm
              })
              adjusted = true
              break
            }
          }
          if (!adjusted) {
            alert('Kunne ikke generere gyldig KID med MOD11 for denne kundeidentifikatoren.')
          }
          return
        }
      }

      this.generatedKids.push({
        uuid: this.uuidv4(),
        value: cleanBase + checkDigit,
        algorithm: this.kidAlgorithm
      })
    },
    calculateKidMOD10CheckDigit(base) {
      // Luhn algorithm
      let sum = 0
      let alternate = true // Start with doubling since we're processing from rightmost of base

      for (let i = base.length - 1; i >= 0; i--) {
        let digit = parseInt(base.charAt(i))

        if (alternate) {
          digit *= 2
          if (digit > 9) {
            digit = Math.floor(digit / 10) + (digit % 10)
          }
        }

        sum += digit
        alternate = !alternate
      }

      return (10 - (sum % 10)) % 10
    },
    calculateKidMOD11CheckDigit(base) {
      const factors = [2, 3, 4, 5, 6, 7]
      let sum = 0

      for (let i = base.length - 1; i >= 0; i--) {
        const factorIndex = (base.length - 1 - i) % factors.length
        sum += parseInt(base.charAt(i)) * factors[factorIndex]
      }

      const remainder = sum % 11
      if (remainder === 0) {
        return 0
      } else if (remainder === 1) {
        return false // Invalid
      } else {
        return 11 - remainder
      }
    },
    fjernKid(uuid) {
      this.generatedKids = this.generatedKids.filter(k => k.uuid !== uuid)
    },

    // IBAN validation methods
    validateIbanChecksum(iban) {
      // Move country code and check digits to end
      const rearranged = iban.substring(4) + iban.substring(0, 4)

      // Convert letters to numbers (A=10, B=11, ..., Z=35)
      let numericIban = ''
      for (let i = 0; i < rearranged.length; i++) {
        const char = rearranged.charAt(i)
        if (/[A-Z]/.test(char)) {
          numericIban += (char.charCodeAt(0) - 55).toString()
        } else {
          numericIban += char
        }
      }

      // Valid IBAN has MOD97 = 1
      return this.mod97(numericIban) === 1
    },
    mod97(numStr) {
      // Calculate MOD 97 for large numbers using string chunking
      let remainder = 0
      for (let i = 0; i < numStr.length; i++) {
        remainder = (remainder * 10 + parseInt(numStr.charAt(i))) % 97
      }
      return remainder
    },

    // Kontonummer validation methods
    validateKontonummerNotNumbers() {
      const cleanNumber = this.typedKontonummer.replace(/[\s.]/g, '')
      if (cleanNumber && !/^\d+$/.test(cleanNumber)) {
        return 'Kontonummer må kun inneholde tall og punktum. '
      }
      return ''
    },
    validateKontonummerLength() {
      const cleanNumber = this.typedKontonummer.replace(/[\s.]/g, '')
      if (cleanNumber && cleanNumber.length > 0 && cleanNumber.length !== 11) {
        return 'Kontonummer må være nøyaktig 11 siffer. '
      }
      return ''
    },
    validateKontonummerMOD11(kontonummer) {
      // Norwegian bank account MOD11 validation
      const factors = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2]
      const checkDigit = parseInt(kontonummer.charAt(10))

      let sum = 0
      for (let i = 0; i < 10; i++) {
        sum += parseInt(kontonummer.charAt(i)) * factors[i]
      }

      const remainder = sum % 11
      const calculatedCheckDigit = remainder === 0 ? 0 : remainder === 1 ? 11 : 11 - remainder

      // If calculated check digit is 11, the account number is invalid
      if (calculatedCheckDigit === 11) {
        return false
      }

      return calculatedCheckDigit === checkDigit
    },

    // KID validation methods
    validateKidNotNumbers() {
      const cleanNumber = this.typedKid.replace(/\s/g, '')
      if (cleanNumber && !/^\d+$/.test(cleanNumber)) {
        return 'KID må kun inneholde tall. '
      }
      return ''
    },
    validateKidLength() {
      const cleanNumber = this.typedKid.replace(/\s/g, '')
      if (cleanNumber && cleanNumber.length > 0 && (cleanNumber.length < 2 || cleanNumber.length > 25)) {
        return 'KID må være mellom 2 og 25 siffer. '
      }
      return ''
    },
    validateKidMOD10(kid) {
      // Luhn algorithm (MOD10)
      let sum = 0
      let alternate = false

      // Start from the rightmost digit, excluding the check digit
      for (let i = kid.length - 2; i >= 0; i--) {
        let digit = parseInt(kid.charAt(i))

        if (alternate) {
          digit *= 2
          if (digit > 9) {
            digit = Math.floor(digit / 10) + (digit % 10)
          }
        }

        sum += digit
        alternate = !alternate
      }

      const calculatedCheckDigit = (10 - (sum % 10)) % 10
      const actualCheckDigit = parseInt(kid.charAt(kid.length - 1))

      return calculatedCheckDigit === actualCheckDigit
    },
    validateKidMOD11(kid) {
      // MOD11 algorithm for KID
      const factors = [2, 3, 4, 5, 6, 7, 2, 3, 4, 5, 6, 7, 2, 3, 4, 5, 6, 7, 2, 3, 4, 5, 6, 7]
      const checkDigit = parseInt(kid.charAt(kid.length - 1))

      let sum = 0
      // Start from the second-to-last digit and work backwards
      for (let i = kid.length - 2; i >= 0; i--) {
        const factorIndex = (kid.length - 2 - i) % factors.length
        sum += parseInt(kid.charAt(i)) * factors[factorIndex]
      }

      const remainder = sum % 11
      let calculatedCheckDigit

      if (remainder === 0) {
        calculatedCheckDigit = 0
      } else if (remainder === 1) {
        return false // Invalid KID if remainder is 1
      } else {
        calculatedCheckDigit = 11 - remainder
      }

      return calculatedCheckDigit === checkDigit
    }
  }
}
</script>

<style scoped>
.kontonummer-container {
  padding: 10px;
}

.nav-tabs {
  margin-bottom: 20px;
}

.tab-content {
  padding: 10px;
}

.description-text {
  width: 80%;
  margin: 20px 0;
}

.card {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}

.badge {
  margin-left: 0.5rem;
}

.alert {
  font-size: 0.875rem;
}

.form-label {
  font-weight: 500;
}

input.form-control {
  font-family: 'Courier New', monospace;
}

.generated-list {
  margin-top: 15px;
}

.generated-item {
  position: relative;
}

.card-content {
  position: relative;
  padding: 10px;
}

.close-button {
  position: absolute;
  top: 8px;
  right: 8px;
}

.copy-button {
  margin-left: 10px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
}

.copy-button:hover {
  opacity: 0.7;
}
</style>
